// applyEdit.js — surgical single-occurrence string replace for the Code agent.
//
// The fix for write_file's destructive-overwrite footgun: to change a few lines
// of an existing file the model must give the EXACT old snippet + the new one,
// and we replace only that span. Unreproduced code can no longer vanish. old
// must be unique (so the edit is unambiguous) and present (so a typo never
// silently no-ops). Pure + testable; the IPC read/write lives in agentTools.

/**
 * @param {string} content   current file content
 * @param {string} oldString exact snippet to replace (must be unique + present)
 * @param {string} newString replacement
 * @returns {{ ok: true, content: string } | { ok: false, error: string }}
 */
export function applyStringEdit(content, oldString, newString) {
  if (typeof content !== 'string') return { ok: false, error: 'conteúdo do arquivo inválido.' };
  if (typeof oldString !== 'string' || typeof newString !== 'string') {
    return { ok: false, error: 'old_string e new_string devem ser strings.' };
  }
  if (oldString === '') return { ok: false, error: 'old_string vazio — informe o trecho exato a substituir.' };
  if (oldString === newString) return { ok: false, error: 'old_string e new_string são iguais — nada a editar.' };
  const occurrences = content.split(oldString).length - 1;
  if (occurrences === 0) {
    // F13-wave8 — hint de RECUPERAÇÃO (padrão Claude Code): quando a 1ª linha do
    // old_string existe no arquivo, o erro mostra a região ATUAL — o modelo
    // corrige na próxima call sem queimar um read_file inteiro. O caso clássico
    // é staleness: o arquivo mudou desde o read (edit anterior no mesmo arquivo).
    return { ok: false, error: `old_string não encontrado no arquivo. Use read_file e copie o trecho EXATO (incl. espaços).${nearMissHint(content, oldString)}` };
  }
  if (occurrences > 1) {
    return { ok: false, error: `old_string aparece ${occurrences}x (ambíguo). Inclua mais linhas de contexto para torná-lo único.` };
  }
  return { ok: true, content: content.replace(oldString, newString) };
}

/** Localiza a 1ª linha não-vazia do old_string no arquivo e devolve a região
 * ATUAL em volta (o que o arquivo REALMENTE tem ali) — '' quando nem a 1ª
 * linha existe (aí o problema não é staleness, é arquivo/trecho errado). */
function nearMissHint(content, oldString) {
  const firstLine = String(oldString).split('\n').map((l) => l.trim()).find((l) => l.length > 3);
  if (!firstLine) return '';
  const lines = content.split('\n');
  const at = lines.findIndex((l) => l.includes(firstLine));
  if (at < 0) return '';
  const region = lines.slice(Math.max(0, at - 1), at + 4).join('\n').slice(0, 400);
  return `\nPROVÁVEL STALENESS: a 1ª linha do seu old_string EXISTE (linha ${at + 1}), mas o resto divergiu — o arquivo mudou desde o seu read. A região ATUAL é:\n---\n${region}\n---\nMonte o old_string a partir DESTE texto.`;
}
